import React from 'react';
import {Box, Link, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2';

const Footer = () => {
    return (
        <Grid container spacing={2}>
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                flexDirection={{ xs: 'column', sm: 'row' }}
                sx={{ fontSize: '12px' }}
                size={12}
            >
                <Grid sx={{ order: { xs: 2, sm: 1} }} size={6}>
                    <Grid>
                        <Box
                        component={'img'}
                        src={process.env.PUBLIC_URL + '/images/vl.png'}
                        height={40}
                        width={40} />
                    </Grid>
                </Grid>
                <Grid container columnSpacing={4} sx={{ order: { xs: 1, sm: 2 } }}>
                    <Grid>
                        <Link
                            underline="none"
                            component="a"
                            href="/privacy"
                            color="text.primary"
                            variant={'subtitle2'}
                        >
                            Privacy Notice
                        </Link>
                    </Grid>
                    <Grid>
                        <Link
                            underline="none"
                            component="a"
                            href="/terms"
                            color="text.primary"
                            variant={'subtitle2'}
                        >
                            Terms of Service
                        </Link>
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                flexDirection={{ xs: 'column', sm: 'row' }}
                sx={{ fontSize: '12px' }}
                size={12}>
                <Grid display="flex" justifyContent="center" alignItems="center" size="grow" rowSpacing={0}>
                    <Typography
                        align={'center'}
                        variant={'subtitle2'}
                        color="text.secondary">
                        &copy; Vampire Labs 2008 - {new Date().getFullYear()}. All rights reserved
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Footer;
